module.exports = __webpack_public_path__ + "img/xizang.0f4e6ab9.png";